export default {
  teams: '/dashboard/teams',
  teamDetais: '/dashboard/teams/:id',
};
